import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

import { BaseSegmentComponent } from '../base/_base-segment.component';
import { segmentsData } from '../../../product-details/segments-data-stub';
import * as utils from 'utils/utils';


@Component({
  moduleId: module.id,
  selector: 'ecommerce-specifications',
  templateUrl: 'specifications.component.html',
  styleUrls: ['specifications.component.scss'],
})
export class SpecificationsComponent extends BaseSegmentComponent implements OnInit {

  fields: Array<string> = [
    'details.brandLabel',
    'partNumber',
    'details.partTerminology.id',
    'details.emissionCode',
  ];
  fieldsSegments: Array<any>;

  secondaryFields: Array<any> = [
    ['details.quantityPerApplication', 'details.quantityPerApplicationUom'],
    ['details.warrantyDistance', 'details.warrantyDistanceUom'],
    ['details.warrantyTime', 'details.warrantyTimeUom'],
    ['details.warrantySpecial', 'details.warrantySpecialUom'],
  ];
  secondaryFieldsSegments: Array<any>;

  attributesSegments: any = segmentsData.attributes;

  get attributes(): Array<any> {
    return _.get(this.itemDetail, 'attributes', []);
  }

  ngOnInit() {
    this.setSegmentItems();
  }

  getItemProperty(item: any): string {
    return utils.getItemProperty(
      item,
      `${item.item_name}`,
      this.itemDetail
    );
  }

  // private
  private setSegmentItems() {
    this.fieldsSegments = _.filter(
      segmentsData.items_details,
      (item: any) => _.includes(this.fields, item.item_name)
    );
    this.secondaryFieldsSegments =
    _.map(this.secondaryFields, (fields: Array<string>) => {
      return _.map(fields, (field: string) => {
        return _.find(segmentsData.items_details, ['item_name', field]);
      });
    });
  }
}
